



































































import { Component, Vue } from "vue-property-decorator";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import { Moment } from "../../../typescript/lib/common/moment";
import { WeekRow } from "../../../typescript/lib/common/types";
import { getRoutePath } from "@/router/routes";
import { getAlertScheduleApi } from "@/typescript/api_client/emesh_api/alert_schedules/alert_schedule_api";
import { GetAlertScheduleResponse } from "@/typescript/api_client/emesh_api/alert_schedules/types";
export { Moment, WeekRow, GetAlertScheduleResponse };
@Component({
  components: {
    ButtonComponent
  }
})
export default class extends Vue {
  // 期間種別 週次
  TERM_WEEKLY: number = 1;

  daysOfWeek: string[] = ["日", "月", "火", "水", "木", "金", "土"];
  calendarDate: WeekRow[][] = [];
  title: string = "";
  dateFormat: string = "YYYY-MM-DD";
  showMonth: Moment = new Moment(this.dateFormat);

  created() {
    this.getToday();
  }

  getToday() {
    this.showMonth = new Moment(this.dateFormat);
    this.getSchedule();
  }

  getPrevMonth() {
    this.showMonth.addDate(-1, "months");
    this.getSchedule();
  }

  getNextMonth() {
    this.showMonth.addDate(1, "months");
    this.getSchedule();
  }

  getSchedule() {
    this.title = this.showMonth.getDateFormat("YYYY年 M月");
    this.calendarDate = Moment.createCalendar(this.showMonth.getFormatDate());

    // 表示するカレンダーの最初の日、最後の日設定
    let startDate = this.calendarDate[0][0].date;
    let weekLen = this.calendarDate.length - 1;
    let dayLen = this.calendarDate[weekLen].length - 1;
    let endDate = this.calendarDate[weekLen][dayLen].date;

    const params = {
      store_id: this.$route.params.store_id,
      start_date: startDate,
      end_date: endDate
    };

    getAlertScheduleApi(params).then((resp: GetAlertScheduleResponse) => {
      resp.schedules.forEach(schedule => {
        schedule.times.forEach(times => {
          if (times.time_schedules.length != 0) {
            let schStartDate = new Moment(
              "YYYYMMDD",
              schedule.start_date
            ).getFormatDate();
            let schEndDate = schedule.end_date
              ? new Moment("YYYYMMDD", schedule.end_date).getFormatDate()
              : "";
            // カレンダーの最後日に設定
            if (schEndDate == "" || Number(schEndDate) > Number(endDate)) {
              schEndDate = endDate;
            }
            // カレンダーの最初日に設定
            if (Number(schStartDate) < Number(startDate)) {
              schStartDate = startDate;
            }
            // 週次以外
            if (schedule.term_type != this.TERM_WEEKLY) {
              this.calendarDate.forEach(week => {
                week.forEach(day => {
                  if (day.date >= schStartDate && day.date <= schEndDate) {
                    day.isSelected = true;
                  }
                });
              });
              // 週次
            } else {
              this.calendarDate.forEach(week => {
                week.forEach(day => {
                  if (day.date >= schStartDate && day.date <= schEndDate) {
                    let monthStartDate = new Moment("YYYYMMDD", day.date);
                    let dayOfWeek = monthStartDate.getDay();

                    const weekSelectedDays: number[] = [
                      schedule.sun_flg,
                      schedule.mon_flg,
                      schedule.tue_flg,
                      schedule.wed_flg,
                      schedule.thu_flg,
                      schedule.fri_flg,
                      schedule.sat_flg
                    ];
                    if (weekSelectedDays[dayOfWeek] == 1) {
                      day.isSelected = true;
                    }
                  }
                });
              });
            }
          }
        });
      });
    });
  }

  showWarningStopTime(startDate: string): void {
    this.$router.push(
      getRoutePath("WarningStopTimeShowPage", {
        store_id: this.$route.params.store_id,
        start_date: startDate,
        end_date: startDate
      })
    );
  }

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }
}
